import PaySuiteMfePage from '@/components/paysuite/PaySuiteMfePage';

const MFE_INSTANCE_ID = '91ab917d-5fd4-4a55-a371-078067e5861f';

export default function PaymentTransactionsListPage() {
  return (
    <PaySuiteMfePage
      title="Payment Transactions"
      description="View and manage payment transactions"
      componentName="transactions-list"
      instanceId={MFE_INSTANCE_ID}
    />
  );
}
